import { render } from "./tradingHall.vue?vue&type=template&id=265ee176&scoped=true"
import script from "./tradingHall.vue?vue&type=script&lang=js"
export * from "./tradingHall.vue?vue&type=script&lang=js"

import "./tradingHall.vue?vue&type=style&index=0&id=265ee176&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ee176"]])

export default __exports__